
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { PartnerForm } from "./PartnerForm";
import { Partner } from "@/hooks/usePartnersManager";

interface PartnerEditDialogProps {
  partner: Partner | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (partner: any) => Promise<void>;
  saving: boolean;
}

export const PartnerEditDialog = ({ 
  partner, 
  open, 
  onOpenChange, 
  onSave,
  saving
}: PartnerEditDialogProps) => {
  const handleSave = async (partnerData: any) => {
    await onSave(partnerData);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {partner ? "Edit Partner" : "Create New Partner"}
          </DialogTitle>
        </DialogHeader>
        <PartnerForm
          partner={partner || undefined}
          onSave={handleSave}
          onCancel={handleCancel}
          saving={saving}
        />
      </DialogContent>
    </Dialog>
  );
};
